import { Component, OnInit, HostListener } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl } from '@angular/forms';
import { DatatableClickEvent } from '@basis/angular-components';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { TabViewModule } from 'primeng/primeng';
import { FieldsetModule } from 'primeng/primeng';
import { MenuItem } from 'primeng/primeng';
import { SelectItem } from 'primeng/primeng';
import { PadraoService } from '../../service/padrao.service';
import { Message } from 'primeng/primeng';
import { SliderModule } from 'primeng/primeng';
import { CrudAcaoEtapa1Component } from '../';
import { CrudAcaoEtapa2Component } from '../';
import { BaseCrudComponent } from "../../base/base-crud.component";
import { environment } from 'environments/environment';
import { concat } from 'rxjs/observable/concat';
import { Acao } from 'app/entity/acao.model'

@Component({
    selector: 'acao-crud',
    templateUrl: 'acao-crud.component.html'
})

export class CrudAcaoComponent extends BaseCrudComponent {
    controllerName = 'acao';

    cadastro = this.formBuilder.group({
        nome: [null, [Validators.required]],
        codigo: [null, [Validators.required]],
        id_situacao: [1],
        id: [null]
    });

    init() {
        super.init();
        super.afterLoad();
    }

    afterLoad() {
        this.cadastro.controls['codigo']
            .setValue(this.cadastro.value.codigo != null ? this.cadastro.value.codigo.toUpperCase().replace(" ", "") : '');
    }

    @HostListener('keyup') UpperCase() {
        if (this.cadastro.value.codigo !== undefined) {
            this.cadastro.controls['codigo']
                .setValue(this.cadastro.value.codigo != null ? this.cadastro.value.codigo.toUpperCase().replace(" ", "") : '');
        }
    }

    finalizar(event: any) {
        this.confirmacao.confirm({
            header: 'Mensagem de Confirmação',
            message: `Atenção! Ao confirmar esta operação, a 'ação' será ${this.acao == 'cadastrar' ? 'salva' : 'atualizada'} na base de dados.
                Deseja realmente confirmar esta operação?`,
            accept: () => {
                this.acao === 'cadastrar' ?
                    this.service.Adicionar(this.controllerName, this.cadastro.getRawValue()).subscribe(
                        sucess => {
                            sessionStorage.setItem("msg", "Registro salvo com sucesso.");
                            this.router.navigate(['../'], { relativeTo: this.activatedRoute });
                        }, err => this.showMsg('warn', 'Mensagem de Erro', `Erro ao gravar. ${err._body}`)
                    ) :
                    this.service.Atualizar(this.controllerName, this.cadastro.getRawValue())
                        .subscribe(
                        sucess => {
                            sessionStorage.setItem("msg", "Registro atualizado com sucesso.");
                            this.router.navigate(['../../'], { relativeTo: this.activatedRoute });
                        }, err => super.showMsg('warn', 'Mensagem de Erro', `Erro ao atualizar. ${err._body}`)
                        );
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/acao/crud/acao-crud.component.ts